import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        contrastThreshold: 10.5,
        primary: {
            main: '#142456',
        },
        success: {
            main: '#00A76A',
        },
        warning: {
            main: '#DC883C',
        },
        error: {
            main: '#D7172F',
        },
    },
});

export default theme;
